import React, { useState } from 'react';
import { Box } from "@mui/material"
import LoginComp from "./login";
import { LoginByNumber, LoginUser } from '../../models/user';
import { pnkstore } from '../../stores/pnk-store';
import { useUserStore } from '../../stores/user-store';
import AppUtils from '../../apputils';
import { useNavigate } from 'react-router-dom';


const Login = () => {

  const [txtLoginEmail, settxtLoginEmail] = useState('');
  const [txtLoginEmailErr, settxtLoginEmailErr] = useState('');
  const [txtLoginPassword, settxtLoginPassword] = useState('');
  const [txtLoginPasswordErr, settxtLoginPasswordErr] = useState('');
  const [login, setLogin] = useState(false);
  const [loginData, setLoginData] = useState({});
  const [alertMsg, setAlertMsg] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState('');
  const userData = useUserStore;
  const navigate = useNavigate();

  if (!window.location.href.includes('login')) {
    window.history.pushState('login', 'Login', 'login');
    window.history.replaceState('login', 'Login', 'login');
  }

  const state = {
    txtLoginEmail: txtLoginEmail,
    txtLoginEmailErr: txtLoginEmailErr,
    txtLoginPassword: txtLoginPassword,
    txtLoginPasswordErr: txtLoginPasswordErr,
    login: login,
    alertMsg: alertMsg,
    showAlert: showAlert,
    alertType: alertType
  }

  const HandleInputs = (e, name) => {
    let value = e.target.value;

    if (name == 'txtLoginEmail') {
      settxtLoginEmail(value);
    }
    else if (name == 'txtLoginPassword') {
      settxtLoginPassword(value);
    }
  }

  const SignIn = () => {
    if (txtLoginEmail.trim() == '') {
      settxtLoginEmailErr('Invalid Email');
      return false;
    }
    else {
      if (txtLoginEmail.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
        settxtLoginEmailErr('');
      }
      else {
        settxtLoginEmailErr('Invalid Email');
        return false;
      }
    }
    if (txtLoginPassword.trim() == '') {
      settxtLoginPasswordErr('Invalid Password');
      return false;
    }
    else {
      settxtLoginPasswordErr('');
    }
    setLoginData({
      txtLoginEmail: txtLoginEmail,
      txtLoginPassword: txtLoginPassword
    })
    // console.log(loginData);
    setLogin(true);
  }

  const handleCloseAlert = () => {
    setShowAlert(false);
    setAlertMsg('');
    setAlertType('');
  }

  const Handleuserloginresponseonse = (res) => {

    console.log(res);

    if (res != false) {
      if (res.data.userloginresponse.rows.msg !== undefined && res.data.userloginresponse.rows.msg !== '') {
        setShowAlert(true);
        setAlertMsg(res.data.userloginresponse.rows.msg);
        setAlertType('error');
      }
      else {
        setShowAlert(true);
        setAlertMsg('Successfully Logged In');
        setAlertType('success');

        let userDetails = res.data.userloginresponse.rows;
        console.log(userDetails);
        let token = res.data.userloginresponse.token;
        userData.setState({ userId: userDetails._id, name: userDetails.userName, username: userDetails.userFullName, email: userDetails.userEmail, mobile: userDetails.userMobile, profile: userDetails.userProfile, token: token, allowedStages: userDetails.allowedStages, allowedRoutes: userDetails.allowedRoutes, allowedBookingStages: userDetails.allowedBookingStages, isLogin: true });
        // navigate('/summary', { replace: true });
        window.location.href = '/institutes';

      }
    }
    else {
      setShowAlert(true);
      setAlertMsg('Wrong Credentials');
      setAlertType('error');
      // 1t631s65
      //AppUtils.ShowMsg(pnkstore.error.prettyMessage)
    }

    setLogin(false);
  }

  return (
    <Box>
      <LoginComp
        state={state}
        login={login}
        SignIn={SignIn}
        HandleInputs={HandleInputs}
        handleCloseAlert={handleCloseAlert}
      />
      {console.log(loginData)}
      {((login === true) ? LoginUser(pnkstore, loginData, Handleuserloginresponseonse) : "")}
    </Box>
  );
}


export default Login;